
// import {get, post, put, download, upload} from '@/config/axios/index'
import request from '@/config/axios'


// send a http get request
export async function httpGet(url, params = {}) {
    return await request.get({url, params})
}


// send a http post request
export async function httpPost(url, data = {}, options = {}) {
    return await request.post({url, data, options});
}

export async function httpPut(url, data = {}, options = {}) {
    return await request.put({url, data, options});
}

export async function httpDownload(url) {
    // return new Promise((resolve, reject) => {
    //     axios({
    //         method: 'GET',
    //         url: url,
    //         responseType: 'blob' // 将响应类型设置为 `blob`
    //     }).then(response => {
    //         resolve(response)
    //     }).catch(err => {
    //         reject(err)
    //     })
    // })
    return await request.download({url})
}

export async function httpPostDownload(url, data) {
    // return new Promise((resolve, reject) => {
    //     axios({
    //         method: 'POST',
    //         url: url,
    //         data: data,
    //         responseType: 'blob' // 将响应类型设置为 `blob`
    //     }).then(response => {
    //         resolve(response)
    //     }).catch(err => {
    //         reject(err)
    //     })
    // })
    return await request.upload({url, data})
}